import { format } from "date-fns";
import useAsyncFunction from "../../hooks/useAsyncFunction"
import BasicTable from "../common/BasicTable";
import Table from "../common/table";
import apiLeituraLinhaLiquido from "../../services/apis/Leituras/apiLeituraLinhaLiquido";
import getCurrentUnidadeId from "../../funcs/getCurrentUnidadeId";

export default function LinhaLiquidoTable() {
        
    const unidadeId = getCurrentUnidadeId();
    const { data, loading, error } = useAsyncFunction(async () => await apiLeituraLinhaLiquido.getEquipamentoComUltimasLeituras(unidadeId, 50)) || [];

    if (loading) return <p>Carregando...</p>;

    if(!data || error) {
        return null
    }
            
    return <BasicTable 
        headerContent={["LEITURA ID", "DATA HORA", "TEMPERATURA", "PRESSÃO CONVERTIDA"]} 
    >   
        {
            data?.map((leitura) => (
            <Table.Row key={leitura.id}>
            <Table.Data>
                    {
                        leitura.id
                    }
                </Table.Data>
                <Table.Data>
                    {
                        format(leitura.dataHora, "dd/MM/yyyy HH:mm:ss")
                    }
                </Table.Data>
                <Table.Data>
                    {
                        leitura.temperatura
                    }
                </Table.Data>
                <Table.Data>
                    {
                        leitura.pressaoConvertida
                    }
                </Table.Data>
            </Table.Row>
            ))
        }
    </BasicTable>

}